module.exports = ".pad40{\r\n    padding:40px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/applicationlist/applicationlist.component.css
// module id = ./src/app/allocation/applicationlist/applicationlist.component.css
// module chunks = main